import React from "react";
import { connect } from "react-redux";
import Request from "../../request";
import { Row, Col, Card } from "antd";
import ListDrawer from './list';
import {
    FaFileAlt, FaPaperPlane, FaHourglassHalf, FaClock, FaFileInvoice, FaFileUpload, FaComments, FaBalanceScale,
    FaCheckCircle, FaChartLine, FaStopwatch, FaExclamationTriangle, FaFileMedical, FaTasks, FaRegCalendarAlt,
    FaCalendarDay, FaCalendarTimes, FaCalendarPlus, FaTimesCircle
} from 'react-icons/fa';






class AdmissionDashboard extends React.Component {
    state = {
        totalApplications: { total: 0, arr: [] },
        applicationsSubmitted: { total: 0, arr: [] },
        applicationsPending: { total: 0, arr: [] },
        offerPending: { total: 0, arr: [] },
        documentsPending: { total: 0, arr: [] },
        additionalDocumentsRequired: { total: 0, arr: [] },
        interviewRequired: { total: 0, arr: [] },
        offersReceived: { total: 0, arr: [] },
        offerRejected: { total: 0, arr: [] },
        pendingApplications: { total: 0, arr: [] },
        missingDocuments: { total: 0, arr: [] },
        counsellorWisePending: {},
        countryWisePending: {},
        offerConversionRatio: 0,
        drawer: false,
        drawerParam: {},
        tommorrowFollowup: {
            total: 0,
            arr: []
        },
        todayFollowup: {
            total: 0,
            arr: []
        },
        missedFollowup: {
            total: 0,
            arr: []
        }
    }


    mergeStatus(defaultObj, apiObj = {}) {
        let result = { ...defaultObj };

        Object.keys(apiObj).forEach(key => {
            if (result[key]) {
                result[key] = {
                    ...result[key],
                    ...apiObj[key]
                };
            }
        });

        return result;
    }

    loadAllApis = async (params = {}) => {

        let response = await Request.loadAdmissionDashboardData();

        this.setState({
            ...response
        });
    };


    componentDidMount() {
        this.loadAllApis();
    }


    render() {
        let { totalApplications, applicationsSubmitted, offerConversionRatio, documentsPending, pendingApplications, missingDocuments, additionalDocumentsRequired, interviewRequired, offersReceived, applicationsPending, offerPending, offerRejected, drawer, drawerParam,
            todayFollowup, tommorrowFollowup, missedFollowup
        } = this.state;
        return (
            <div className="fod-container">
                <h4 className="fod-heading">Admission Counsellor</h4>
                {drawer && <ListDrawer param={drawerParam} onClose={() => this.setState({ drawer: false })} />}
                <div className="section-tag">Application Status</div>
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-blue">
                                <FaFileAlt />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Total Applications</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Total Applications", arr: totalApplications.arr, count: totalApplications.total, bgColorClass: "bg-blue", icon: <FaFileAlt /> } })}>{totalApplications.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* Applications Overview */}

                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-blue elevation-1"><FaFileAlt /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Total Applications">Total Applications</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Total Applications", arr: totalApplications.arr, count: totalApplications.total } })}>
                                        {totalApplications.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-green elevation-1"><FaPaperPlane /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Applications Submitted">Applications Submitted</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Applications Submitted", arr: applicationsSubmitted.arr, count: applicationsSubmitted.total } })}>
                                        {applicationsSubmitted.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-green">
                                <FaPaperPlane />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Applications Submitted</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Applications Submitted", arr: applicationsSubmitted.arr, count: applicationsSubmitted.total, bgColorClass: "bg-green", icon: <FaPaperPlane /> } })}>{applicationsSubmitted.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-yellow elevation-1"><FaHourglassHalf /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Applications Pending">Applications Pending</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Applications Pending", arr: applicationsPending.arr, count: applicationsPending.total } })}>
                                        {applicationsPending.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-yellow">
                                <FaHourglassHalf />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Applications Pending</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Applications Pending", arr: applicationsPending.arr, count: applicationsPending.total, bgColorClass: "bg-yellow", icon: <FaHourglassHalf /> } })}>
                                        {applicationsPending.total}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-orange elevation-1"><FaClock /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Offer Pending">Offer Pending</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Offer Pending", arr: offerPending.arr, count: offerPending.total } })}>
                                        {offerPending.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-orange">
                                <FaClock />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Offer Pending</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Offer Pending", arr: offerPending.arr, count: offerPending.total, bgColorClass: "bg-orange", icon: <FaClock /> } })}>
                                        {offerPending.total}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="section-tag">Applications Processing</div>
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-red">
                                <FaFileInvoice />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Documents Pending</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Documents Pending", arr: documentsPending.arr, count: documentsPending.total, bgColorClass: "bg-red", icon: <FaFileInvoice /> } })}>
                                        {documentsPending.total}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-red elevation-1"><FaFileInvoice /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text" title="Documents Pending">Documents Pending</span>
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Documents Pending", arr: documentsPending.arr, count: documentsPending.total } })}>
                                            {documentsPending.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </Col> */}

                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-purple">
                                <FaFileUpload />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Additional Documents Required</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Additional Documents Required", arr: additionalDocumentsRequired.arr, count: additionalDocumentsRequired.total, bgColorClass: "bg-purple", icon: <FaFileUpload /> } })}>
                                        {additionalDocumentsRequired.total}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-purple elevation-1"><FaFileUpload /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Additional Documents Required">Additional Documents Required</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Additional Documents Required", arr: additionalDocumentsRequired.arr, count: additionalDocumentsRequired.total } })}>
                                        {additionalDocumentsRequired.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}

                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-cyan">
                                <FaComments />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Interview Required</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Interview Required", arr: interviewRequired.arr, count: interviewRequired.total, bgColorClass: "bg-cyan", icon: <FaComments /> } })}>
                                        {interviewRequired.total}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-cyan elevation-1"><FaComments /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Interview Required">Interview Required</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Interview Required", arr: interviewRequired.arr, count: interviewRequired.total } })}>
                                        {interviewRequired.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-color-11">
                                <FaBalanceScale className="dash-icon" />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Offer Received Vs Pending Vs Rejected</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a>{offersReceived.total} / {offerPending.total} / {offerRejected.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-11 elevation-1"><FaBalanceScale className="dash-icon" /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title={`Offer Received Vs Pending Vs Rejected`}>Offer Received Vs Pending Vs Rejected</span>
                                <span className="info-box-number">
                                    <a>{offersReceived.total} / {offerPending.total} / {offerRejected.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                </Row>

                <div className="section-tag">Follow Ups</div>
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-indigo">
                                <FaCalendarDay />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Today's Followup</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Today Followup", arr: todayFollowup.arr, count: todayFollowup.total, bgColorClass: "bg-indigo", icon: <FaCalendarDay /> }
                                        })}>{todayFollowup.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-blue elevation-1"><FaCalendarDay /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Followup</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({
                                        drawer: true,
                                        drawerParam: { title: "Today Followup", arr: todayFollowup.arr, count: todayFollowup.total }
                                    })}>{todayFollowup.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col> */}

                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-teal">
                                <FaCalendarPlus />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Tommorrow's Followup</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Tommorrow Followup", arr: tommorrowFollowup.arr, count: tommorrowFollowup.total, bgColorClass: "bg-teal", icon: <FaCalendarPlus /> }
                                        })}>{tommorrowFollowup.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-blue elevation-1"><FaCalendarPlus /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Tommorrow's Followup</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({
                                        drawer: true,
                                        drawerParam: { title: "Today Followup", arr: tommorrowFollowup.arr, count: tommorrowFollowup.total }
                                    })}>{tommorrowFollowup.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-red-soft">
                                <FaCalendarTimes />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Missed Followup</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Missed Followup", arr: missedFollowup.arr, count: missedFollowup.total, bgColorClass: "bg-red-soft", icon: <FaCalendarTimes /> }
                                        })}>{missedFollowup.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-blue elevation-1"><FaCalendarTimes /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Missed Followup</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({
                                        drawer: true,
                                        drawerParam: { title: "Missed Followup", arr: missedFollowup.arr, count: missedFollowup.total }
                                    })}>{missedFollowup.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                </Row>

                <div className="section-tag">AC Performance</div>
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-green">
                                <FaCheckCircle />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Offers Received</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Offers Received", arr: offersReceived.arr, count: offersReceived.total, bgColorClass: "bg-green", icon: <FaCheckCircle /> } })}>
                                            {offersReceived.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-red">
                                <FaTimesCircle />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Offers Rejected</div>
                                <div className="stat-value">
                                    <a
                                        onClick={() =>
                                            this.setState({
                                                drawer: true,
                                                drawerParam: {
                                                    title: "Offers Rejected",
                                                    arr: offerRejected.arr,
                                                    count: offerRejected.total,
                                                    bgColorClass: "bg-red",
                                                    icon: <FaTimesCircle />
                                                }
                                            })
                                        }
                                    >
                                        {offerRejected.total}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-green elevation-1"><FaCheckCircle /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Offers Received">Offers Received</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Offers Received", arr: offersReceived.arr, count: offersReceived.total } })}>
                                        {offersReceived.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-color-12">
                                <FaChartLine />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Applications → Offer Conversion Ratio</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a>
                                            {offerConversionRatio + "%"}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-12 elevation-1"><FaChartLine /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Applications → Offer Conversion Ratio">Applications → Offer Conversion Ratio</span>
                                <span className="info-box-number">
                                    <a>
                                        {offerConversionRatio + "%"}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-color-13">
                                <FaStopwatch />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Application Processing Time</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Application Processing Time", arr: interviewRequired.arr, count: interviewRequired.total, bgColorClass: "bg-color-13", icon: <FaStopwatch /> } })}>
                                            {interviewRequired.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-13 elevation-1"><FaStopwatch /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Application Processing Time">Application Processing Time</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Application Processing Time", arr: interviewRequired.arr, count: interviewRequired.total } })}>
                                        {interviewRequired.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                </Row>



                <div className="section-tag">Alerts</div>
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-dark-red">
                                <FaExclamationTriangle />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Application Pending 48+ Hours</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Application Pending", arr: pendingApplications.arr, count: pendingApplications.total, bgColorClass: "bg-dark-red", icon: <FaExclamationTriangle /> } })}>
                                            {pendingApplications.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-dark-red elevation-1 dash-icon"><FaExclamationTriangle /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Application Pending 48+ Hours">Application Pending 48+ Hours</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Application Pending", arr: pendingApplications.arr, count: pendingApplications.total } })}>
                                        {pendingApplications.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-darkblue">
                                <FaClock />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Time-sensitive applications</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Time-sensitive applications", arr: interviewRequired.arr, count: interviewRequired.total, bgColorClass: "bg-darkblue", icon: <FaClock /> } })}>
                                            {interviewRequired.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-darkblue elevation-1"><FaClock /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Time-sensitive applications">Time-sensitive applications</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Time-sensitive applications", arr: interviewRequired.arr, count: interviewRequired.total } })}>
                                        {interviewRequired.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-pink">
                                <FaFileMedical />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Missing Documents</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Missing Documents", arr: missingDocuments.arr, count: missingDocuments.total, bgColorClass: "bg-pink", icon: <FaFileMedical /> } })}>
                                            {missingDocuments.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-pink elevation-1"><FaFileMedical /></span>
                            <div className="info-box-content">
                                <span className="info-box-text" title="Missing Documents">Missing Documents</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Missing Documents", arr: missingDocuments.arr, count: missingDocuments.total } })}>
                                        {missingDocuments.total}
                                    </a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                </Row>
                <Row className="fod-row" gutter={[24, 0]}>
                    {/* Country Wise Card */}
                    <Col span={12}>
                        {Object.keys(this.state.countryWisePending || {}).length > 0 && (
                            <Card
                                title="Pending Applications Country Wise"
                                className="modern-list-card"
                                style={{ marginTop: 20 }}
                                bodyStyle={{ padding: "12px 0" }} // Removes default card padding for custom rows
                            >
                                <div className="card-list-container">
                                    {Object.keys(this.state.countryWisePending).map((key) => {
                                        const item = this.state.countryWisePending[key];
                                        return (
                                            <div className="list-item-row" key={key}>
                                                <span className="label-text">
                                                    {key}
                                                </span>
                                                <div
                                                    className="count-badge"
                                                    onClick={() => this.setState({
                                                        drawer: true,
                                                        drawerParam: {
                                                            title: key + " Pending Applications",
                                                            arr: item.arr,
                                                            count: item.total,
                                                            bgColorClass: "bg-blue"
                                                        }
                                                    })}
                                                >
                                                    {item.total}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Card>
                        )}
                    </Col>

                    {/* Counsellor Wise Card */}
                    <Col span={12}>
                        {Object.keys(this.state.counsellorWisePending || {}).length > 0 && (
                            <Card
                                title="Pending Applications Counsellor Wise"
                                className="modern-list-card"
                                style={{ marginTop: 20 }}
                                bodyStyle={{ padding: "12px 0" }} // Removes default card padding for custom rows
                            >
                                <div className="card-list-container">
                                    {Object.keys(this.state.counsellorWisePending).map((key) => {
                                        const item = this.state.counsellorWisePending[key];
                                        return (
                                            <div className="list-item-row" key={key}>
                                                <span className="label-text">
                                                    {key}
                                                </span>
                                                <div
                                                    className="count-badge"
                                                    onClick={() => this.setState({
                                                        drawer: true,
                                                        drawerParam: {
                                                            title: key + " Pending Applications",
                                                            arr: item.arr,
                                                            count: item.total,
                                                            bgColorClass: "bg-blue"
                                                        }
                                                    })}
                                                >
                                                    {item.total}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Card>
                        )}
                    </Col>
                    {/* <Col span={12}>
                        {Object.keys(this.state.counsellorWisePending || {}).length > 0 && (
                            <Card
                                title="Pending Applications Counsellor Wise"
                                className="modern-list-card"
                                style={{ marginTop: 20 }}
                            >
                                {Object.keys(this.state.counsellorWisePending).map((key) => {
                                    const item = this.state.counsellorWisePending[key];
                                    return (
                                        <div className="list-item-row" key={key}>
                                            <span className="label-text">{key}</span>
                                            <span
                                                className="count-link"
                                                onClick={() => this.setState({
                                                    drawer: true,
                                                    drawerParam: {
                                                        title: key + " Pending Applications",
                                                        arr: item.arr,
                                                        count: item.total,
                                                        bgColorClass: "bg-blue"
                                                    }
                                                })}
                                            >
                                                {item.total}
                                            </span>
                                        </div>
                                    );
                                })}
                            </Card>
                        )}
                    </Col> */}
                </Row>
            </div >
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (AdmissionDashboard)